
const Main = () => import('@/views/main');
const basicsSetPages = () => import('@/views/integral/basicsSet');
const grade = () => import('@/views/integral/grade');
const detail = () => import('@/views/integral/detail');
const addVipLevel = () => import('@/views/integral/addVipLevel');


export default [{
    path: '/basicsSet',
    name: 'basicsSet',
    redirect: '/basicsSetPages',
    component: Main,
    meta: {
        hide: false,
        name: '积分管理',
        unfold: true,
		iconType: "4"
    },
    children: [
        {
            path: '/basicsSetPages',
            name: 'basicsSetPages',
            component: basicsSetPages,
            meta: {
                name: '基础设置'
            },
        },
        {
            path: '/grade',
            name: 'grade',
            component: grade,
            meta: {
                name: '会员等级设置'
            },
            children: [
                {
                    path: "addVipLevel",
                    component: addVipLevel,
                    name: "addVipLevel",
                    meta: {
                        name: '新增会员等级'
                    },
                }
            ]
        },
        {
            path: '/detail',
            name: 'detail',
            component: detail,
            meta: {
                name: '积分明细'
            },
        },
    ]
}]

